import type {
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'
import type { UserDetail } from '@/types/user'

import { updateUserDetails } from './services/mutateUsers'
import { invalidateLoadUserDetails } from './useLoadUsers'

type Props = {
  updateUserDetails: (data: Partial<UserDetail>) => Promise<UserDetail>
} & UseMutationResult<UserDetail, unknown, Partial<UserDetail>, unknown>

export const useUpdateUserDetails = (
  options: Omit<
    UseMutationOptions<UserDetail, unknown, Partial<UserDetail>, unknown>,
    'mutationKey' | 'mutationFn' | 'onSuccess'
  > = {}
): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.USERS.UPDATE_DETAILS],
    mutationFn: async (data: Partial<UserDetail>) => updateUserDetails(data),
    onSuccess: async () => {
      await invalidateLoadUserDetails()
    },
    ...options,
  })

  const updateUserDetailsReq = async (data: Partial<UserDetail>) => {
    return mutation.mutateAsync(data)
  }

  return {
    updateUserDetails: updateUserDetailsReq,
    ...mutation,
  }
}
